module.exports = __webpack_public_path__ + "media/index_djembe.d0b69183.mp4";